import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as locations from '../../../../constants/dropdown';
import {messageTextValidation, nameValidation, emailValidation, phoneValidation} from '../../../../utils/itemValidation';

import * as commonActionCreators from '../../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

import RhinoSelect from '../../../common/inputs/RhinoSelect';


class Valentines2021 extends React.Component {

	static propTypes = {
		location: PropTypes.object
	};

	static contextTypes = {
		store: PropTypes.any,
		router: React.PropTypes.object.isRequired
	};

	constructor(props) {
		super(props);

		const firstEntry = [{display: 'Location*', 'value': ''}];
		const firstEntryNotReq = [{display: 'Location', 'value': ''}];
	    const finalEntry = [{display: 'Other', 'value': 'online@diamondsdirect.com'}];

	    // Link format:
	    // https://ddw2.diamondsdirect.com/img/designers/logos/tacori.svg


	    let newArray= firstEntryNotReq.concat(locations.locations).concat(finalEntry);
	    let designerArray = [
	    	{
	    		display: 'Designer', 
	    		value: '',
	    		page: '',
	    		image: '',
	    		stores: '|',
	    	},
	    	{
	    		display: 'Simon G.', 
	    		value: 'Simon G.',
	    		page: 'simon-g-jewelry',
	    		image: 'simong.svg',
	    		stores: '|cle|ftx|nol|boc|ral|okc|vab|san|dfw|ind|',
	    	},
	    	{
	    		display: 'Tacori', 
	    		value: 'Tacori',
	    		page: 'tacori',
	    		image: 'tacori.svg',
	    		stores: '|atx|chs|',
	    	},
	    	{
	    		display: 'Uneek', 
	    		value: 'Uneek',
	    		page: 'uneek',
	    		image: 'uneek.svg',
	    		stores: '|jax|',
	    	},
	    	{
	    		display: 'Verragio', 
	    		value: 'Verragio',
	    		page: 'verragio',
	    		image: 'ver.svg',
	    		stores: '|clt|bhm|coh|rva|stl|',
	    	},
	    ];
	    

	    let designerLocationArray = [
	    	{
				display: 'Select Location',
				value: '',
			},
	    	{
				display: 'Austin, TX',
				value: 'atx',
			},
			{
				display: 'Birmingham, AL',
				value: 'bhm',
			},
			{
				display: 'Boca Raton, FL',
				value: 'boc',
			},
			{
				display: 'Charleston, SC',
				value: 'chs',
			},
			{
				display: 'Charlotte, NC',
				value: 'clt',
			},
			{
				display: 'Cleveland, OH',
				value: 'cle',
			},
			{
				display: 'Columbus, OH',
				value: 'coh',
			},
			{
				display: 'Dallas, TX',
				value: 'dfw',
			},
			{
				display: 'Frisco, TX',
				value: 'ftx',
			},
			{
				display: 'Indianapolis, IN',
				value: 'ind',
			},
			{
				display: 'Jacksonville, FL',
				value: 'jax',
			},
			{
				display: 'Kansas City, KS',
				value: 'kcy',
			},
			{
				display: 'New Orleans, LA',
				value: 'nol',
			},
			{
				display: 'Oklahoma City, OK',
				value: 'okc',
			},
			{
				display: 'Raleigh, NC',
				value: 'ral',
			},
			{
				display: 'Richmond, VA',
				value: 'rva',
			},
			{
				display: 'St. Louis, MO',
				value: 'stl',
			},
			{
				display: 'San Antonio, TX',
				value: 'san',
			},
			{
				display: 'Virginia Beach, VA',
				value: 'vab',
			},
	    ];

		this.state = {
			locations: newArray,
			designers: designerArray,
			designerLocationArray: designerLocationArray,
			// displayArray: designerArray,
			inputName: '',
			inputEmail: '',
			inputPhone: '',
			inputLocation: '',
			inputMessage: '',
			inputDesigner: '',
			designerLocation: '',
			errorName: null,
			errorEmail: null,
			errorPhone: null,
			errorLocation: null,
			errorMessage: null,
			errorDesigner: null,
			errorDesignerLocation: null,
		};
	}

	internalNav(page) {
		this.context.router.push('/' + page);
	}

	externalNav(page) {
		window.location.href = '/' + page;
	}

	dd1Nav(page) {
		window.location.href = 'https://diamondsdirect.com/' + page;	
	}

	giftsNav(page) {
		window.location.href = 'https://gifts.diamondsdirect.com';
	}

	openNew(page) {
		let win = window.open(page, '_blank');
		win.focus();
	}

	getLoctionUrl(locationCode) {

		switch(locationCode) {
			case 'atx':
				return 'austin';
			case 'bhm':
				return 'birmingham';
			case 'boc':
				return 'boca-raton';
			case 'chs':
				return 'charleston';
			case 'clt':
				return 'charlotte';
			case 'cle':
				return 'cleveland';
			case 'coh':
				return 'columbus';
			case 'dfw':
				return 'dallas';
			case 'ftx':
				return 'frisco';
			case 'ind':
				return 'indianapolis';
			case 'jax':
				return 'jacksonville';
			case 'kcy':
				return 'kansas-city';
			case 'nol':
				return 'new-orleans';
			case 'okc':
				return 'oklahoma-city';
			case 'ral':
				return 'raleigh';
			case 'rva':
				return 'richmond';
			case 'stl':
				return 'st-louis';
			case 'san':
				return 'san-antonio';
			case 'vab':
				return 'virginia-beach';
		}
		return '';
	}

	getLocationDesigners() {
		return [];
	}

	changeName(evt) {
		this.setState({ inputName: evt.target.value }, () => {
			if(this.state.errorName && !nameValidation(this.state.inputName)) {
				this.setState({ errorName: null });
			}
		});
	}

	changeEmail(evt) {
		this.setState({ inputEmail: evt.target.value }, () => {
			if(this.state.errorEmail && !emailValidation(this.state.inputEmail)) {
				this.setState({ errorEmail: null });
			}
		});
	}

	changePhone(evt) {
		this.setState({ inputPhone: evt.target.value }, () => {
			if(this.state.errorPhone && !phoneValidation(this.state.inputPhone)) {
				this.setState({ errorPhone: null });
			}
		});
	}

	changeLocation(evt) {
		this.setState({ inputLocation: evt.target.value}, () => {
			if(this.state.errorLocation !== false && this.state.inputLocation !== '') {
				this.setState({errorLocation: null});
			}
		});
	}

	changeDesigner(evt) {
		this.setState({ inputDesigner: evt.target.value });
	}

	changeDesignerLocation(evt) {
		this.setState({ designerLocation: evt.target.value });
	}

	submitContactRequest() {
		if(this.validateAll()) {

			let contactData = {
				full_name: this.state.inputName,
				email: this.state.inputEmail,
				phone: this.state.inputPhone,
				location: this.state.inputLocation,
			}

			this.props.commonSummerContactRequest(contactData);
			// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
			this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
			this.setState({
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				inputDesigner: '',
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
			});
		}
	}

	validateAll() {

    let hasErrors = true;
    
    // Required params
    let nameError = nameValidation(this.state.inputName);
    let emailError = emailValidation(this.state.inputEmail);
    let locationError = nameValidation(this.state.inputLocation);

    // Optional params
    let phoneError = null;
    if(this.state.inputPhone) {
      phoneError = phoneValidation(this.state.inputPhone);
    }

    if(nameError === null &&
       emailError === null &&
       phoneError === null &&
       locationError === null) {
      hasErrors = false;
    }

    this.setState({
      errorName: nameError,
      errorEmail: emailError,
      errorPhone: phoneError,
      errorLocation: locationError,
    }, () => {
    	console.log(this.state);
    });

    return !hasErrors;
  }

	render() {
		return <div className='Valentines2021'>
			<div className='formSection'>
				<div className='formHeader'>
					<img className='desktop600' src='https://ddw2.diamondsdirect.com/img/promopages/valentines2021/landing/assets/val_land_head.jpg' />
					<img className='mobile600' src='https://ddw2.diamondsdirect.com/img/promopages/valentines2021/landing/assets/val_land_head_m.jpg' />
				</div>
				<div className='formUpperSection'>
					<div className='fuP'>This Valentine's Day, give the one you love the gift that lets them know you want them to be yours forever!</div>
					<div className='fuP'>Shop with us online or in-store to take advantage of:</div>
					<div className='fuBox'>
						<div className='box1'>0% APR for 60 Months*</div>
						<div className='box2'>Subject to credit approval.</div>
						<div className='box3'>Available Now - Feb 15</div>
						<div className='boxButton' onClick={() => this.openNew('https://retailservices.wellsfargo.com/ahapp/init-app?m=2171050826')}><div>Learn More &amp; Apply</div></div>
					</div>
					<div className='fuP'><span className='fuPBold'>Special hours Valentine's Day, February 14th</span><br />12 p.m. - 5 p.m.</div>
				</div>
				<div className='designersSection'>

					<div className='designersP'>Internationally renowned designers will be showcasing expanded, one-of-a-kind collections of fine jewelry February 12-14. Select your Diamonds Direct location below to see which designer will be coming to your area!</div>
					<div className='designersSelectWrapper'>
						<RhinoSelect
							selectClass={'summerSelect'}
							required={true}
							value={this.state.designerLocation}
							options={this.state.designerLocationArray}
							changeMethod={(evt) => this.changeDesignerLocation(evt)}
							error={this.state.errorLocation} />
					</div>
					<div className='designerResultsWrapper'>
						{this.state.designers.map((designer, i) => {

							if(this.state.designerLocation === '') {
								return;
							}

							if(designer.stores.includes(this.state.designerLocation)) {
								return <div className='designerWrapper' key={i} onClick={() => this.internalNav(this.getLoctionUrl(this.state.designerLocation))}>
									<img src={'https://ddw2.diamondsdirect.com/img/promopages/singledesigner2020/' + designer.image} />
								</div>;
							} else {
								return null;
							}
						})}
					</div>
				</div>
				<div className='formBoxWrapper'>
					<div className='formInnerWrapper'>
						
						<div className='formP'>Walk-in visits are always welcome, but due to precautions and state and local ordinances, showroom space may be limited. We also have our virtual appointment tool so you can continue to shop from the comfort of your own home!</div>

						<div className='formWrapper'>
							<div className='formInputWrapper'>
								<input 
									className={this.state.errorName ? 'textInput error' : 'textInput'}
									type='text' 
									placeholder='Full Name*'
									value={this.state.inputName}
                					onChange={::this.changeName} />
							</div>
							<div className='formInputWrapper'>
								<input 
									className={this.state.errorEmail ? 'textInput error' : 'textInput'}
									type='email' 
									placeholder='Email Address*'
									value={this.state.inputEmail}
                					onChange={::this.changeEmail} />
							</div>
							<div className='formInputWrapper'>
								<input 
									className={this.state.errorPhone ? 'textInput error' : 'textInput'}
									type='text' 
									placeholder='Telephone'
									value={this.state.inputPhone}
                					onChange={::this.changePhone} />
							</div>
							<div className='formInputWrapper'>
								<RhinoSelect
					                selectClass={'summerSelect'}
					                required={true}
					                value={this.state.inputLocation}
					                options={this.state.locations}
					                changeMethod={(evt) => this.changeLocation(evt)}
					                error={this.state.errorLocation !== null} />
							</div>
							<div className='formActionRow'>
								<button className={'formAction'} onClick={::this.submitContactRequest}>Request an appointment</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className='trendsSection'>
				<div className='trendsTitle'>
					<img src='https://ddw2.diamondsdirect.com/img/promopages/valentines2021/landing/assets/romantic.svg' />
				</div>
				<div className='trendsBlock'>
					<div className={'trendsLeft trendsImgBlock'}>
						<div className={'trendsFirst trendsImgBlock'}>
							<div className={'trendsTop trendsImgBlock'} onClick={() => this.externalNav('tacori-chain-amethyst-bracelet-SB16701.html')}></div>
							<div className={'trendsBottom trendsImgBlock'} onClick={() => this.externalNav('diamonds-direct-designs-engagement-ring-4P1814E.html')}></div>
						</div>
						<div className={'trendsSecond trendsImgBlock'} onClick={() => this.externalNav('simon-g-diamond-butterfly-pendant-NFANC19655.html')}></div>
					</div>
					<div className={'trendsRight trendsImgBlock'} onClick={() => this.externalNav('verragio-engagement-ring--5.html')}></div>
				</div>
			</div>
			<div className='designersSection'>
				<div className='designersTitle'>
					<img src='https://ddw2.diamondsdirect.com/img/promopages/valentines2021/landing/assets/val_gg.svg' />
				</div>
				<div className='designersHr'>
					<img className='desktopOnly' src='https://ddw2.diamondsdirect.com/img/promopages/valentines2021/landing/assets/trunkshow_line.svg' />
					<img className='mobileOnly' src='https://ddw2.diamondsdirect.com/img/promopages/valentines2021/landing/assets/trunkshow_line.svg' />
				</div>
				<div className='designersP'>Diamonds Direct invites you to enjoy this season with a little extra sparkle!</div>
				<div className='designersP'>Shop our favorite gift guide items in our showrooms or from the comfort of your own home and make this a season to remember!</div>
				<div className='designersSelectWrapper'>
					<div className='ggButton' onClick={::this.giftsNav}>SHOP VALENTINE GIFTS</div>
				</div>
			</div>
			<div className='footerSection'>
				<div className='footerWrapper'>
					<div className='footerProduct' onClick={() => this.dd1Nav('diamonds-direct-designs-14k-rose-gold-fashion-ring-RNGSP03465.html')}>
						<div className='footerImg'>
							<img src='https://ddw2.diamondsdirect.com/img/promopages/valentines2021/landing/assets/oval.jpg' />
						</div>
						<div className='footerLabel'>Oval Morganite and Diamond Bezel Ring</div>
					</div>
					<div className='footerProduct' onClick={() => this.dd1Nav('tacori-stud-earrings-TACSS00295.html')}>
						<div className='footerImg'>
							<img src='https://ddw2.diamondsdirect.com/img/promopages/valentines2021/landing/assets/amethyst.jpg' />
						</div>
						<div className='footerLabel'>Tacori Purple Amethyst Stud Earrings</div>
					</div>
					<div className='footerProduct' onClick={() => this.dd1Nav('odelia-14k-white-gold-fashion-ring-BLDXL07221.html')}>
						<div className='footerImg'>
							<img src='https://ddw2.diamondsdirect.com/img/promopages/valentines2021/landing/assets/xdesign.jpg' />
						</div>
						<div className='footerLabel'>"X" Design Ring</div>
					</div>
					<div className='footerProduct' onClick={() => this.dd1Nav('amden-necklace-necklace-NFANC23870.html')}>
						<div className='footerImg'>
							<img src='https://ddw2.diamondsdirect.com/img/promopages/valentines2021/landing/assets/pendants.jpg' />
						</div>
						<div className='footerLabel'>Mixed-Cut Diamond Mosaic Double Row Necklace</div>
					</div>
				</div>


				<div className='footerLegal'>*Subject to credit approval. Cannot be combined with other offers or discounts.</div>
			</div>
		</div>;
	}
}
export default Valentines2021;

function mapStateToProps(state) {
  return {

  };
}

export const Valentines2021Container = connect(
  mapStateToProps,
  allActionCreators
)(Valentines2021);


// WEBPACK FOOTER //
// ./src/components/views/promopages/valentines2021/Valentines2021.jsx